module.exports = __webpack_public_path__ + "img/interior-tiles.f85e60a2.svg";